import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const ApiMethodRow = styled.span`
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px 7px 5px 7px;
  border-bottom: 1px solid ${colors.borderGray};
`;

export const ApiMethodItem = styled.span`
  ${({ push }) =>
    push &&
    css`
      margin-left: auto;
    `}
`;

export const DeleteIcon = styled.i.attrs({ className: 'fa-solid fa-trash' })`
  color: ${({ theme }) => theme.freecode.color} !important;
  margin-right: 10px;
`;

export const ApiModalInput = styled.input`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid ${({ theme }) => theme.freecode.headerDropShadow} !important;
  background: ${({ theme }) => theme.freecode.headerBackground};
  color: ${({ theme }) => theme.freecode.color};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;

export const ApiTypeSelect = styled.select`
  outline: 0 none !important;
  box-shadow: none !important;
  padding: 0.7em;
  padding: 0.375rem 0.75rem;
  color: ${({ theme }) => theme.freecode.color};
  background: ${({ theme }) => theme.freecode.headerBackground};
  border: 1px solid ${({ theme }) => theme.freecode.headerDropShadow};
  border-radius: 0.3rem;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.freecode.headerBackground};
  }
`;

export const ApiModalLabel = styled.label`
  display: block;
  margin-top: 1rem;
`;

export const ApiParametersRow = styled.div.attrs({ className: 'row' })`
  ${({ marginBottom = '0.5rem' }) => css`
    margin-bottom: ${marginBottom};
  `}
  max-width: 100%;
`;

export const ApiParameterCol = styled.div.attrs(({ col = 'col-6' }) => ({ className: col }))`
  margin-bottom: 0.5rem;
`;

export const ApiParameterChildContainer = styled.div`
  margin-top: 0.5rem;
  margin-left: 1rem;
`;

export const ApiParameterDeleteContainer = styled.div.attrs({ className: 'col-1' })`
  line-height: 2.5;
  & i {
    cursor: pointer;
    color: ${colors.darkGray};
  }
`;

export const ApiParameterLabel = styled.label`
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.freecode.color};
`;

export const ErrorMessage = styled.p`
  color: ${colors.red} !important;
  font-size: 12px;
  padding: 0.25rem;
  margin-bottom: 0;
`;

export const ModalTextArea = styled.textarea`
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.freecode.headerDropShadow};
  background: ${({ theme }) => theme.freecode.headerBackground};
  color: ${({ theme }) => theme.freecode.color};
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  width: 100%;
  min-height: 100px;
  max-height: 100%;
  :focus {
    outline: none !important;
  }
`;
